module.exports = __webpack_public_path__ + "img/commonBtnMiddle.c73c7455.png";